import { render, staticRenderFns } from "./RoleInfo.vue?vue&type=template&id=3915fbf0"
import script from "./RoleInfo.vue?vue&type=script&lang=js"
export * from "./RoleInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports